import {
	moveHamburgerToNavigationButtons,
	moveLoginToNavigationButtons,
	setHeaderTopHeightVariable,
	moveTopNavToHeader,
	setStickyHeader,
	moveBannerToMenu,
	createMenuLevel2Wrap,
	createMenuLevel2Headers,
	moveTopNavMenuToHeader,
	moveCurrencySwitcher,
} from '../modules/header'
import { createCarouselDots } from '../modules/carousel'
import { createElement, turnTelToLink } from '../modules/globalFunctions'
import {
	makeFilterTitlesClickable,
	createShowSubcategoriesButton,
	categoryHead,
	handleTopProducts,
	createCategoryWrapper,
	handleTotalProductCount,
	changeTextInFilterBtn,
} from '../modules/category'
import {
	handleProductTop,
	createAddToCartWrapper,
	turnProductImgToCarousel,
	handleFavoritesIcon,
	handleFlagsOnDetail,
	changeTextOfLinkToDescription,
	createShpTabLink,
} from '../modules/productDetail'
import { addLinkToArticles } from '../modules/blog'

window.language = dataLayer[0].shoptet.language

// COMONLY USED
turnTelToLink()

// HEADER
moveLoginToNavigationButtons()
moveHamburgerToNavigationButtons()
moveTopNavMenuToHeader()
setHeaderTopHeightVariable()
setStickyHeader()
createMenuLevel2Wrap()
moveBannerToMenu()
moveCurrencySwitcher()
// CAROUSEL
createCarouselDots()
// END OF COMONLY USED

/*
 * This function moves the next-to-carousel-banners block to the right place and creates slick slider and heading.
 * It is used on the homepage.
 */
const handleNextToCarouselBanners = () => {
	const banners = document.querySelector('.next-to-carousel-banners')
	if (!banners) return

	const firstProductsBlock = document.querySelector('.products-block')
	if (!firstProductsBlock) return
	firstProductsBlock.parentElement.insertBefore(banners, firstProductsBlock.nextElementSibling)

	const heading = createElement('div', ['homepage-group-title', 'h4'], 'Oblíbené kategorie')
	banners.parentElement.insertBefore(heading, banners)

	const slickSettings = {
		slidesToShow: 6,
		infinite: false,
		dots: true,
		responsive: [
			{
				breakpoint: 1300,
				settings: {
					slidesToShow: 5,
				},
			},
			{
				breakpoint: 1100,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 2.7,
					dots: false,
					arrows: false,
				},
			},
		],
	}
	$(banners).slick(slickSettings)
}

const moveBenefitBanner = () => {
	const benefitBanner = document.querySelector('.benefitBanner')
	const benefitPlaceholder = document.querySelector('#usp-placeholder')
	if (!benefitBanner || !benefitPlaceholder) return
	benefitPlaceholder.innerHTML = ''
	benefitPlaceholder.appendChild(benefitBanner)
}

// HOMEPAGE
if (dataLayer[0].shoptet.pageType === 'homepage') {
	handleNextToCarouselBanners()
	moveBenefitBanner()
}

// CATEGORY
if (dataLayer[0].shoptet.pageType === 'category') {
	handleTopProducts()
	createCategoryWrapper()
	makeFilterTitlesClickable()
	createShowSubcategoriesButton('Ukázat více')
	handleTotalProductCount()
	changeTextInFilterBtn()
	document.addEventListener('ShoptetDOMContentLoaded', () => {
		createCategoryWrapper()
		makeFilterTitlesClickable()
		createShowSubcategoriesButton('Ukázat více')
		handleTotalProductCount()
		changeTextInFilterBtn()
	})
}

// PRODUCT DETAIL
if (dataLayer[0].shoptet.pageType === 'productDetail') {
	handleProductTop()
	document.addEventListener('ShoptetDOMContentLoaded', handleProductTop)
	createAddToCartWrapper()
	handleFlagsOnDetail()
	changeTextOfLinkToDescription()
	const extendedDescription = document.querySelector('.extended-description')
	if (extendedDescription) {
		extendedDescription.id = 'parameters'
		const infoWrapper = document.querySelector('.p-info-wrapper')
		const linkToParameters = createElement('a', ['link-to-parameters'], window.language == 'cs' ? 'Parametry' : 'Parametre')
		linkToParameters.href = '#parameters'
		if (infoWrapper) infoWrapper.appendChild(linkToParameters)
		const shpTabParameters = createShpTabLink(window.language == 'cs' ? 'Parametry' : 'Parametre', '#parameters')
		const detailTabs = document.querySelector('.p-detail-tabs')
		if (detailTabs) detailTabs.firstElementChild.after(shpTabParameters)
	}

	const pMainImage = document.querySelector('.p-main-image')
	const pImageWrapper = document.querySelector('.p-image-wrapper')
	const thumbnailsWrapper = document.querySelector('.p-thumbnails-wrapper')
	if (pMainImage) {
		const clickToZoom = createElement(
			'div',
			['click-to-zoom'],
			window.language == 'cs' ? 'Kliknutím zvětšíte obrázek' : 'Kliknutím zväčšíte obrázok',
		)

		if (thumbnailsWrapper) clickToZoom.classList.add('with-thumbnails')
		pMainImage.appendChild(clickToZoom)
	}

	document.addEventListener('dkLabFavouriteProductsLoaded', handleFavoritesIcon)
}

// BLOG
if (document.body.classList.contains('type-posts-listing')) {
	addLinkToArticles()
}

// BLOG POST
if (document.body.classList.contains('type-post')) {
	const newsItemDetail = document.querySelector('.news-item-detail')
	if (newsItemDetail) {
		const nextPrev = document.querySelector('.next-prev')
		if (nextPrev) newsItemDetail.after(nextPrev)

		const spanImage = newsItemDetail.querySelector('span[itemprop="image"] meta[itemprop="url"]')
		if (spanImage) {
			const image = createElement('img', ['news-item-detail-image'])
			image.src = spanImage.content
			newsItemDetail.before(image)
		}
	}
}
